import { FC, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Card, CardActions, CardContent, CardHeader, Grid, Radio, TableContainer, Typography, } from '@material-ui/core';
import { CustomerAddress } from 'src/interfaces/new-channel-partner/channelPartner';
import { getAddressLine1, getAddressLine2 } from 'src/utils/address';
import { AddCustomerAddress } from '../dialogs/addAddress';

interface AddressCardProps {
  addresses: CustomerAddress[];
  setAddress?: (data: CustomerAddress) => void;
  addAddress?: (data: CustomerAddress) => Promise<boolean>;
  enableRaiseRequest: boolean;
}

export const AddressCard: FC<AddressCardProps> = (props) => {
  const { addresses, setAddress, addAddress, enableRaiseRequest } = props;
  const [selectedAddress, setSelectedAddress] = useState<string>('');
  const [openAddAddressDialog, setOpenAddAddressDialog] = useState(false);

  const selectedAddressData = (addressData: CustomerAddress) => {
    setAddress(addressData);
  };

  const renderAddressText = (name: string) => (
    <Typography
      display="block"
      variant="caption"
    >
      {name}
    </Typography>
  );

  const showAllCards = () => {
    const addressArray = [];
    for (let i = 0; i < addresses?.length; i++) {
      addressArray.push(
        <Grid
          key={addresses[i].id}
          item
          display="grid"
          md={3}
          xs={12}
          sm={6}
          minWidth="200px"
        >
          <Card
            variant="outlined"
          >
            <CardHeader
              sx={{
                py: 1,
                pl: 2,
                borderBottom: 0
              }}
              title={addresses[i].name}
              action={enableRaiseRequest && (
                <>
                  <Radio
                    checked={selectedAddress === addresses[i].id}
                    onChange={() => {
                      setSelectedAddress(addresses[i].id);
                      selectedAddressData(addresses[i]);
                    }}
                  />
                </>
              )}
            />
            <CardContent
              sx={{
                py: 1,
              }}
            >
              {renderAddressText(getAddressLine1(addresses[i]))}
              {renderAddressText(getAddressLine2(addresses[i]))}
            </CardContent>
            <CardActions
              sx={{
                p: 0
              }}
            />
          </Card>
        </Grid>
      );
    }
    return addressArray;
  };

  return (
    <>
      <Card
        variant="outlined"
        sx={{ mt: 1 }}
      >
        <CardHeader
          title="Address"
          action={(
            <>
              <Button
                size="small"
                variant="contained"
                onClick={() => setOpenAddAddressDialog(true)}
              >
                Add
              </Button>
            </>
          )}
        />
        {addresses.length > 0 && (
        <CardContent>
          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              md={12}
              xs={12}
              sm={12}
            >
              <TableContainer
                sx={{
                  maxHeight: '300px'
                }}
              >
                <Grid
                  container
                  spacing={2}
                >
                  {showAllCards()}
                </Grid>
              </TableContainer>
            </Grid>
          </Grid>
        </CardContent>
        )}
      </Card>
      <AddCustomerAddress
        open={openAddAddressDialog}
        onClose={() => setOpenAddAddressDialog(false)}
        addAddress={addAddress}
      />
    </>
  );
};

AddressCard.propTypes = {
  addresses: PropTypes.array,
  setAddress: PropTypes.func,
  addAddress: PropTypes.func,
  enableRaiseRequest: PropTypes.bool
};
